module.exports = __webpack_public_path__ + "img/russia.67a379e8.svg";